export default __webpack_public_path__ + "static/media/lancamentos-mais-recentes-1.9a197bbe.png";